import { defineComponent as _defineComponent } from 'vue'
import { TtIntake } from "@/CodegenTypes";
import { times } from "lodash";
import { formatCount } from "@/helpers/formatCount";
import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TTIntakeDetailsModal',
  props: {
    data: null,
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: TtIntake[];
  value: boolean;
};





const startIndex = ref(0);
const PER_PAGE = 40;

const rowsPerTable = computed(() => {
  return PER_PAGE / 2;
});

const totalEntriesCount = computed(() => {
  return processedIntakeData.value.length;
});

const processedIntakeData = computed(() => {
  const processedDataMap = props.data.reduce((result, d) => {
    let existingData = result[d.numbersText];

    if (existingData) {
      existingData = {
        ...d,
        unit: existingData.unit + d.unit,
        entriesCount: existingData.entriesCount + 1,
      };
    } else {
      existingData = {
        ...d,
        entriesCount: 1,
      };
    }
    result[d.numbersText] = existingData;
    return result;
  }, {} as { [s: string]: any });

  const processedData = Object.values(processedDataMap);

  return processedData.sort((a, b) => {
    const lengthDiff = a.numbersText.length - b.numbersText.length;
    if (lengthDiff) return lengthDiff;

    return a.numbersText.localeCompare(b.numbersText);
  });
});

const intakesInPage = computed(() => {
  const endIndex = startIndex.value + PER_PAGE;
  return processedIntakeData.value.slice(startIndex.value, endIndex);
});

const firstTable = computed(() => {
  const dataRows = intakesInPage.value.slice(0, rowsPerTable.value);
  const rowsToPad = rowsPerTable.value - dataRows.length - 1;
  const padRows = [] as any[];
  times(rowsToPad, () => {
    padRows.push({ number: "", unit: "", mode: "" });
  });
  return [...dataRows, ...padRows];
});

const secondTable = computed(() => {
  const dataRows = intakesInPage.value.slice(rowsPerTable.value);
  const rowsToPad = rowsPerTable.value - dataRows.length - 1;
  const padRows = [] as any[];
  times(rowsToPad, () => {
    padRows.push({ number: "", unit: "", mode: "" });
  });
  return [...dataRows, ...padRows];
});

function toggleModal(val: boolean) {
  emit("input", val);
}

watch(
  () => props.value,
  (val) => {
    if (!val) {
      startIndex.value = 0;
    }
  }
);

return { __sfc: true,props, emit, startIndex, PER_PAGE, rowsPerTable, totalEntriesCount, processedIntakeData, intakesInPage, firstTable, secondTable, toggleModal, formatCount }
}

})